import { PixiBase } from './PixiBase';

export class DrawerBase extends PixiBase {
  constructor() {
    super();
    this._observers = [];
  }

  execute(root) {
    throw new Error('Pls implement execute method');
  }

  getContainer(name) {
    let container = this.__containers[name];
    if (container) {
    } else {
      container = this.createContainer(name);
      this.__containers[name] = container;
    }
    return container;
  }

  createApplication(config) {
    return new this.PIXI.Application(config);
  }

  createContainer(name) {
    const container = new this.PIXI.Container();
    if (name) {
      container.name = name;
    }
    return container;
  }

  createSpine(source) {
    return new this.PIXI.spine.Spine(source.spineData);
  }

  addChildToSlot(slotName, child, index = 0) {
    const slot = this.getSlot(slotName);
    if (slot) {
      (slot.children[index] || slot).addChild(child);
      return true;
    }
    return false;
  }

  getSlot({ texture, name }) {
    const index = texture.spineData.slots.findIndex(slotData => slotData.name === name);
    return texture.children[index];
  }

  createSprite(source) {
    return new this.PIXI.Sprite(source.texture);
  }

  createLoader() {
    return new this.PIXI.Loader();
  }

  setPosition(element, { x = 0, y = 0 } = {}) {
    element.x = x;
    element.y = y;
  }

  setSizes(element, { w = 0, h = 0 }) {
    element.width = w;
    element.height = h;
  }

  setPivot(element, { x, y }) {
    element.x = x;
    element.y = y;
  }

  createGroup(zIndex = 0) {
    return new this.PIXI.display.Group(zIndex, true);
  }

  createLayer(group) {
    return new this.PIXI.display.Layer(group);
  }

  createGraphics() {
    return new this.PIXI.Graphics();
  }

  addSubscriber(obs) {
    this._observers.push(obs);
    return obs;
  }

  destroy() {
    this._observers.forEach(obs => {
      obs.unsubscribe();
    });
    this._observers = [];
  }

  calculatePosition({ element, containerName, position = { x: 0, y: 0 } }) {
    if (!element.parent) {
      return position;
    }

    if (element.parent.name === containerName) {
      return position;
    }

    const newPosition = {
      x: position.x + element.parent.position.x,
      y: position.y + element.parent.position.y,
    };

    return this.calculatePosition({
      element: element.parent,
      containerName,
      position: newPosition,
    });
  }

  setupButtonMode(texture, { interactive = true, buttonMode = true } = {}) {
    texture.interactive = interactive;
    texture.buttonMode = buttonMode;
  }

  registerClick(texture, onClick) {
    return texture.on('pointerdown', onClick);
  }

  registerPointerover(texture, event) {
    return texture.on('pointerover', event);
  }

  registerPointerout(texture, event) {
    return texture.on('pointerout', event);
  }

  registerPointerup(texture, event) {
    return texture.on('pointerup', event);
  }
}
